import { findByKeyword, findByKeyword2 } from '@/api/ik/data/dataApi'

export const DataTableMixin = {
  props: {
    url: { type: String, default: 'health/content/label/contentlabel' },
    searchKeyWord: { type: String, default: "" },
    chDiagContent: { type: String, default: "" }, // 中医病名诊断内容
    prescriptionTypeSign: { type: Number, default: null },
    // 新增参数
    storeCode: { type: String, default: "" }, // 门店编码
    diagContent: { type: String, default: "" }, // 西医病
    chYndromeContent: { type: String, default: "" }, // 中医症
    phyContent: { type: String, default: "" }, // 体质
    tabContent: { type: String, default: "" } // 标签
  },
  data() {
    return {
      loading: false,
      data: [],
      pagination: { pageSize: 5, pageNo: 1, total: 0 }
    }
  },
  computed: {
    // 根据URL判断是否为中成药处方
    isMedPrescription() {
      return this.url && this.url.includes('stdmedprescription')
    },
    // 根据URL判断是否为中药处方（饮片）
    isChmedPrescription() {
      return this.url && this.url.includes('stdprescription') && !this.url.includes('stdmedprescription')
    },
    keywordApi() {
      // 中成药使用 getMedPrescription，中药饮片使用 getPrescription
      if (this.isMedPrescription) {
        return findByKeyword
      } else {
        return findByKeyword2
      }
    }
  },
  methods: {
    getData(keyword, callback = () => {}) {
      this.loading = true

      let params

      // 根据处方类型构造对应参数
      if (this.isMedPrescription) {
        // 标准中成药处方参数
        params = {
          storeCode: this.storeCode,
          diagContent: this.diagContent || '',
          chDiagContent: this.chDiagContent || '',
          chYndromeContent: this.chYndromeContent || '',
          phyContent: this.phyContent || '',
          tabContent: this.tabContent || '',
          keyword: keyword.trim()
        }
      } else {
        // 标准中药处方（饮片）参数
        // type=1: 推荐处方（携带chDiagContent），type=2: 标准搜索
        const type = this.$route?.query?.type
        params = {
          storeCode: this.storeCode,
          prescriptionTypeSign: this.prescriptionTypeSign,
          // 推荐模式下使用传入的chDiagContent，标准模式下可为空或依赖keyword
          chDiagContent: type === '1' ? (this.chDiagContent || '') : (this.chDiagContent || ''),
          keyword: keyword.trim()
        }
      }

      this.keywordApi(this.url, params)
        .then(res => {
          this.data = res.data
          callback()
        })
        .finally(() => {
          this.loading = false
        })
    },

    pageChange(page) {
      this.pagination.pageNo = page
      this.getData(this.searchKeyWord)
    },

    search(callback) {
      this.pagination.pageNo = 1
      this.getData(this.searchKeyWord, callback)
    }
  }
}
